// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EndpointsError } from './EndpointsError';
import {
  EndpointsErrorFromJSON,
  EndpointsErrorFromJSONTyped,
  EndpointsErrorToJSON,
  EndpointsErrorToJSONTyped,
} from './EndpointsError';
import type { InternalendpointsListSessionsResponse } from './InternalendpointsListSessionsResponse';
import {
  InternalendpointsListSessionsResponseFromJSON,
  InternalendpointsListSessionsResponseFromJSONTyped,
  InternalendpointsListSessionsResponseToJSON,
  InternalendpointsListSessionsResponseToJSONTyped,
} from './InternalendpointsListSessionsResponse';

/**
 *
 * @export
 * @interface InternalSessionsGet200Response
 */
export interface InternalSessionsGet200Response {
  /**
   *
   * @type {InternalendpointsListSessionsResponse}
   * @memberof InternalSessionsGet200Response
   */
  data?: InternalendpointsListSessionsResponse;
  /**
   *
   * @type {Array<EndpointsError>}
   * @memberof InternalSessionsGet200Response
   */
  errors?: Array<EndpointsError>;
}

/**
 * Check if a given object implements the InternalSessionsGet200Response interface.
 */
export function instanceOfInternalSessionsGet200Response(
  value: object,
): value is InternalSessionsGet200Response {
  return true;
}

export function InternalSessionsGet200ResponseFromJSON(
  json: any,
): InternalSessionsGet200Response {
  return InternalSessionsGet200ResponseFromJSONTyped(json, false);
}

export function InternalSessionsGet200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalSessionsGet200Response {
  if (json == null) {
    return json;
  }
  return {
    data:
      json['data'] == null
        ? undefined
        : InternalendpointsListSessionsResponseFromJSON(json['data']),
    errors:
      json['errors'] == null
        ? undefined
        : (json['errors'] as Array<any>).map(EndpointsErrorFromJSON),
  };
}

export function InternalSessionsGet200ResponseToJSON(
  json: any,
): InternalSessionsGet200Response {
  return InternalSessionsGet200ResponseToJSONTyped(json, false);
}

export function InternalSessionsGet200ResponseToJSONTyped(
  value?: InternalSessionsGet200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: InternalendpointsListSessionsResponseToJSON(value['data']),
    errors:
      value['errors'] == null
        ? undefined
        : (value['errors'] as Array<any>).map(EndpointsErrorToJSON),
  };
}
